import { FormInput_text } from 'components/form/formInput/FormInput_text';
import React from 'react';

export default function CompanyInfo({
    setupInfo
}) {
    return (
        <>
            <div className={"common-inputs__row-1"}>
                {/* Company Id */}
                <FormInput_text
                    className={"row-1__company-id"}
                    inputLabel={"COM ID"}
                    inputValue={setupInfo?.CompanyId}

                    isInputOptional isMarginBtmOptional isInputDisabled
                />

                {/* Account Code */}
                <FormInput_text
                    className={"row-1__account-code"}
                    inputLabel={"Account Code"}
                    inputValue={setupInfo?.AccountCode}

                    isInputOptional isMarginBtmOptional isInputDisabled
                />
            </div>
             
            <div className={"common-inputs__row-2"}>
                {/* Dealer Code */}
                <FormInput_text
                    className={"row-2__dealer-code"}
                    inputLabel={"Dealer Code"}
                    inputValue={setupInfo?.DealerCode}

                    isInputOptional isMarginBtmOptional isInputDisabled
                />

                {/* Sales Person Code */}
                <FormInput_text
                    className={"row-2__account-code"}
                    inputLabel={"Sales Person Code"}
                    inputValue={setupInfo?.SalesPersonCode}

                    isInputOptional isMarginBtmOptional isInputDisabled
                />
            </div>
        </>
    );
}